import React from 'react';
import _get from 'lodash/get';
import { TFunction } from 'i18next';
import { CompanyDomain } from 'graphql-common';
import { CellProps } from '@lib/components/Table/types';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { ChipTypes } from '@lib/components/Chip/Chip';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateTimeFormatEU } from '@lib/enums/dateTime';

type Args = {
  t: TFunction<'translation', undefined>;
};

export default function getTableColumns({ t }: Args) {
  return [
    {
      id: 'domain',
      Header: t('domain'),
      accessor: 'domain',
      Cell: (props: CellProps<CompanyDomain>) => <TextCell {...props} />,
      minWidth: 250,
      maxWidth: 400,
      width: 250,
      sortable: true,
    },
    {
      id: 'verified',
      Header: t('status'),
      Cell: (props: CellProps<CompanyDomain>) => {
        const { item } = props;
        const verified = _get(item, 'verified') as boolean;
        return (
          <ChipCell
            label={verified ? t('verified') : t('pending')}
            type={verified ? ChipTypes.chipGreen : ChipTypes.chipYellow}
          />
        );
      },
      minWidth: 120,
      maxWidth: 180,
      width: 120,
    },
    {
      id: 'createdAt',
      Header: t('added-date'),
      accessorFn: ({ item }: CellProps<CompanyDomain>) =>
        item.createdAt
          ? getFormattedDate(item.createdAt, dateTimeFormatEU)
          : '-',
      Cell: (props: CellProps<CompanyDomain>) => <TextCell {...props} />,
      sortable: true,
      minWidth: 180,
      maxWidth: 250,
      width: 180,
    },
  ];
}
